import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const Root = styled.div`
  display: flex;
  flex-direction: column;
`

export const Header = styled.div``

export const Footer = styled.div`
  ${({ theme }) => `
    margin-top: ${theme.space.mobile.base};
  `}

  ${({ theme }) => media.sm`
    margin-top: ${theme.space.desktop.base};
  `}
`
